// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Hom0","inputWrap":"Table_inputWrap__27tML","col":"Table_col__1PHjV","bmiTooltip":"Table_bmiTooltip__1Ing0"};